import { PageHeader } from "antd";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import TabsComp from "../../Layouts/Tabs";
import Modules from "./Modules";
import Roles from "./Roles";
import UserLogs from "./UserLogs";
import Users from "./Users";

const FibraDetails = (props) => {
    const { onBack, fibra_id, title } = props;
    const [t] = useTranslation('global');

    return (
        <Fragment>
            <PageHeader
                ghost={true}
                onBack={() => onBack()}
                title={title}
                subTitle={t(`super-admin.subtitle`)}
            ></PageHeader>
            <TabsComp
                tablist={[
                    t(`super-admin.tabs.module-web`),
                    t(`super-admin.tabs.module-app`),
                    t(`super-admin.tabs.roles`),
                    t(`super-admin.tabs.users`),
                    t(`super-admin.tabs.logs`)
                ]}
                tabpanels={[
                    <Modules key='web' fibra_id={fibra_id} app_id={1} />,
                    <Modules key='mobile' fibra_id={fibra_id} app_id={2} />,
                    <Roles key='roles' fibra_id={fibra_id} />,
                    <Users key='users' fibra_id={fibra_id} />,
                    <UserLogs key='logs' fibra_id={fibra_id} />
                ]}
            />
        </Fragment>
    );
}

export default FibraDetails